import { createContext, useEffect, useState } from 'react';
import { SBOM_TYPES } from '../components/SBOM/SBOM.constants';

export const AssetsContext = createContext({
  tasks: null,
  setTasks: () => {},
  updateStatus: () => {},
  currentAsset: null,
  setCurrentAsset: () => {},
  isAssetExcluded: null,
  setRecentlyUploadedAsset: () => {},
  recentlyUploadedAsset: null
});

function NRAssetsDataShare({ children }) {
  const [tasks, setTasks] = useState([]);
  const [currentAsset, setCurrentAsset] = useState(null);
  const [isAssetExcluded, setIsAssetExcluded] = useState(null);
  const [recentlyUploadedAsset, setRecentlyUploadedAsset] = useState();

  const updateStatus = (status, uploadUrl, downloadUrl) => {
    if (uploadUrl) {
      const currentUploadIndex = tasks.findIndex(e => e.uploadUrl === uploadUrl);
      if (currentUploadIndex !== -1) {
        const newTasks = [...tasks];
        newTasks[currentUploadIndex].status = status;
        setTasks(newTasks);
      }
    } else if (downloadUrl) {
      const currentUploadIndex = tasks.findIndex(e => e.downloadUrl === downloadUrl);
      if (currentUploadIndex !== -1) {
        const newTasks = [...tasks];
        newTasks[currentUploadIndex].status = status;
        setTasks(newTasks);
      }
    }
  };

  useEffect(() => {
    if (currentAsset && SBOM_TYPES.includes(currentAsset.type)) {
      setIsAssetExcluded(true);
    } else if (currentAsset === null || (isAssetExcluded && !SBOM_TYPES.includes(currentAsset.type))) {
      setIsAssetExcluded(false);
    }
  }, [currentAsset]);

  const defaultValues = {
    tasks,
    setTasks,
    updateStatus,
    currentAsset,
    setCurrentAsset,
    isAssetExcluded,
    recentlyUploadedAsset,
    setRecentlyUploadedAsset
  };
  return <AssetsContext.Provider value={defaultValues}>{children}</AssetsContext.Provider>;
}

export default NRAssetsDataShare;
